class Gradient {
  public startColor: string;
  public stopColor: string;
  public startOffset: number;
  public stopOffset: number;
  public x1: number;
  public y1: number;
  public x2: number;
  public y2: number;

  constructor(
    startColor: string,
    stopColor: string,
    startOffset: number,
    stopOffset: number,
    x1: number,
    y1: number,
    x2: number,
    y2: number
  ) {
    this.startColor = startColor;
    this.stopColor = stopColor;
    this.startOffset = startOffset;
    this.stopOffset = stopOffset;
    this.x1 = x1;
    this.y1 = y1;
    this.x2 = x2;
    this.y2 = y2;
  }
}

class Point {
  public x: number;
  public y: number;

  constructor(
    x: number,
    y: number
  ) {
    this.x = x;
    this.y = y;
  }
}

interface TransitionWobbleProps {
  sourcePath: undefined | null | string,
  targetPath: undefined | null | string,
  sourceGradient: undefined | null | Gradient,
  targetGradient: undefined | null | Gradient,
  sourceOrigin: undefined | null | Point,
  targetOrigin: undefined | null | Point,
  sourceSize: undefined | null | Point,
  targetSize: undefined | null | Point,
}

export {
  Gradient,
  Point,
  TransitionWobbleProps,
}
